import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  Chip,
  CircularProgress,
  Paper,
} from "@mui/material";
import { Warning } from "@mui/icons-material";
import { ICarrier } from "../../interfaces/configuration";

interface CarrierStatusModalProps {
  open: boolean;
  carrier: ICarrier | null;
  onConfirm: () => void;
  onCancel: () => void;
  loading: boolean;
}

export const CarrierStatusModal: React.FC<CarrierStatusModalProps> = ({
  open,
  carrier,
  onConfirm,
  onCancel,
  loading,
}) => {
  if (!carrier) return null;

  const willEnable = !carrier.enabled;
  const actionLabel = willEnable ? "habilitar" : "deshabilitar";
  const actionLabelCapitalized = willEnable ? "Habilitar" : "Deshabilitar";

  return (
    <Dialog open={open} onClose={onCancel} maxWidth="sm" fullWidth>
      <DialogTitle>
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <Warning color="warning" />
          <Typography variant="h6">
            Confirmar {actionLabelCapitalized}
          </Typography>
        </Box>
      </DialogTitle>

      <DialogContent>
        <Typography variant="body1" sx={{ mb: 3 }}>
          Estás a punto de {actionLabel} el siguiente operador logístico:
        </Typography>

        <Paper
          variant="outlined"
          sx={{
            p: 2,
            display: "flex",
            alignItems: "center",
            gap: 2,
            backgroundColor: "#fafafa",
          }}
        >
          <Box sx={{ flex: 1 }}>
            <Typography variant="subtitle1" fontWeight={600}>
              {carrier.name}
            </Typography>
            <Box sx={{ display: "flex", gap: 1, mt: 1, flexWrap: "wrap" }}>
              <Chip
                label={carrier.type === "PARTNER" ? "Partner" : "Tradicional"}
                size="small"
                color={carrier.type === "PARTNER" ? "primary" : "default"}
                variant="outlined"
              />
              <Chip
                label={carrier.enabled ? "Habilitado" : "Deshabilitado"}
                size="small"
                color={carrier.enabled ? "success" : "error"}
              />
            </Box>
          </Box>
        </Paper>
      </DialogContent>

      <DialogActions sx={{ p: 2, gap: 1 }}>
        <Button onClick={onCancel} disabled={loading} color="inherit">
          Cancelar
        </Button>
        <Button
          onClick={onConfirm}
          disabled={loading}
          variant="contained"
          color={willEnable ? "success" : "error"}
          startIcon={
            loading ? <CircularProgress size={16} color="inherit" /> : null
          }
        >
          {loading ? "Guardando..." : `${actionLabelCapitalized}`}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
